export default __webpack_public_path__ + "static/media/waterdrop.0225d00d.mp3";